<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Consulta Geral</h2>
    <h3>Projetos</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="search">
      <input type="text" class="form-control" aria-describedby="basic-addon1" [(ngModel)]="filter_pesquisa" (keyup)="pesquisaRapida()" autocomplete="off">
      <span class="icon-search" id="basic-addon1">
        <img src="assets/images/svgs/pesquisa.svg" alt="Pesquisar">
      </span>
    </div>
    <div class="imprimir">
      <button class="btn btn-primary" type="btn" (click)="openPrintModal()">
        <img src="assets/images/svgs/print.svg" alt="Imprimir">
      </button>
    </div>
    <div class="new-project" *ngIf="canCreate">
      <a class="btn btn-primary" routerLink="adicionar">Novo Projeto</a>
    </div>
  </div>
</div>

<div class="open-filters" *ngIf="!filterActive">
  <button class="btn-filters-close" type="button" (click)="filterActive = true">
    <img src="assets/images/svgs/Filtros.svg">
  </button>
</div>

<div *ngIf="filterActive" class="wrapper wrapper-content animated fadeInRight" [@slideIn]="filterActive">
  <div class="row">
    <div class="col-12">
      <div class=" float-e-margins">
        <div class="form_search">
          <div class="m-b">
            <div class="form-group form-filter">
              <h3>Filtros</h3>
              <div class="col-8 d-flex justify-content-end">
                <button class="btn-filters" type="button" (click)="advancedSearch()">
                  <img src="assets/images/svgs/{{!advancedSearchActive ? 'Mais' : 'Menos' }}_filtros.svg">
                  <span>{{ labelAdvancedSearch }}</span>
                </button>
                <button class="btn-filters" type="button" (click)="cleanSearch()">
                  <img src="assets/images/svgs/Limpar_filtros.svg">
                  <span>Limpar Filtros</span>
                </button>
                <button class="btn-filters-close" type="button" (click)="closeFilter()">
                  <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                </button>
              </div>
            </div>
          </div>
          <form [formGroup]="form" ng-controller="MyCtrl">
            <div class="form-group row">
              <div class="m-b" [ngClass]="{'col-sm-4': advancedSearchActive, 'col-sm-8': !advancedSearchActive}">
                <label class="col-sm-12 pb-1">Órgão do Projeto</label>
                <ng-select id="filter_agency" class="ng-select-alternative" [items]="orgaoList" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos" formControlName="filter_agency">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b" *ngIf="advancedSearchActive">
                <label class="col-sm-12 pb-1">Órgão do Programa</label>
                <ng-select id="filter_agency_pg_type1" class="ng-select-alternative" [items]="orgaoList" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos" formControlName="filter_agency_pg_type1">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b" *ngIf="advancedSearchActive">
                <label class="col-sm-12 pb-1">Órgão do Projeto Agregador</label>
                <ng-select id="filter_agency_pg_type2" class="ng-select-alternative" [items]="orgaoList" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos" formControlName="filter_agency_pg_type2">
                </ng-select>
              </div>
            </div>
            <div class="form-group row" *ngIf="advancedSearchActive">
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Programa</label>
                <ng-select id="filter_pg_type1" class="ng-select-alternative" [items]="programaList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_pg_type1">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Projeto Agregador</label>
                <ng-select id="filter_pg_type2" class="ng-select-alternative" [items]="agregadorList" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_pg_type2">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Eixo Estratégico</label>
                <ng-select id="filter_axis" class="ng-select-alternative" [items]="eixoList" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_axis">
                </ng-select>
              </div>
            </div>
            <div class="form-group row" *ngIf="advancedSearchActive">
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Status Operacional</label>
                <ng-select id="filter_op_status_id" class="ng-select-alternative" [items]="statusList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_op_status_id">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Objetivo Estratégico</label>
                <ng-select id="filter_objective" class="ng-select-alternative" [items]="objEstrategicoList" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_objective">
                </ng-select>
              </div>
              <div class="col-sm-4 m-b">
                <label class="col-sm-12 pb-1">Com inconsistências no cadastro</label>
                <ng-select id="filter_with_warn" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_with_warn">
                </ng-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-2 col-sm-3 m-b">
                <label class="col-sm-12 pb-1">Ativo</label>
                <ng-select id="filter_actived" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_actived">
                </ng-select>
              </div>
              <div class="col-md-2 col-sm-3 m-b">
                <label class="col-sm-12 pb-1">Estratégicos</label>
                <ng-select id="filter_level_priority" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_level_priority">
                </ng-select>
              </div>
              <div class="col-md-2 col-sm-3 m-b">
                <label class="col-sm-12 pb-1">
                  <span>IRFE </span>
                  <i class="pl-1 fa fa-info-circle icon" tooltip="{{ irfeProjetoService.LABEL_TOOLTIP }}" placement="bottom"></i>
                </label>
                <ng-select id="filter_irfe_enabled_id" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_irfe_enabled_id">
                </ng-select>
              </div>
              <div class="col-md-2 col-sm-3  m-b">
                <label class="col-sm-12 pb-1">
                  <span>IRCP </span>
                  <i class="pl-1 fa fa-info-circle icon" tooltip="{{ ircpProjetoService.LABEL_TOOLTIP }}" placement="bottom"></i>
                </label>
                <ng-select id="filter_ircp_enabled_id" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_ircp_enabled_id">
                </ng-select>
              </div>
              <div class="col-md-4"></div>
              <ng-container  formArrayName="filter_tags">
                <div class="col-md-2 col-sm-3  m-b" formGroupName="0">
                  <label class="col-sm-12 pb-1">
                    <span>Plano Rio Grande </span>                  
                  </label>
                  <ng-select id="status" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="status">
                  </ng-select>
                </div>
                <div class="col-md-2 col-sm-3  m-b" formGroupName="1">
                  <label class="col-sm-12 pb-1">
                    <span>Plano de Desenvolvimento </span>                  
                  </label>
                  <ng-select id="status" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="status">
                  </ng-select>
                </div>
              </ng-container>
              <div class="col-md-6 col-sm-4"></div>
              <div class="col-sm-2 m-b">
                <div class="search-button">
                  <button type="button" (click)="search(true)">Filtrar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="system-table">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Projetos</th>
          <th>Órgão</th>
          <!-- <th>Previsto</th>
          <th>Executado</th> -->
          <th class="text-center">Status</th>
          <th>Atualização</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let projeto of projetoPesquisa | paginate: { 
              itemsPerPage: pagination.itemsPerPage, 
              currentPage: pagination.currentPage, 
              totalItems: projetoPesquisa?.length}">
          <tr>
            <td class="title">
              <span class="title-span">{{projeto?.title}}</span>
              <div class="responsavel">
                <img *ngIf="projeto?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="projeto?.resp_nome" placement="bottom" (click)="viewResonsavel(projeto)">
                <div *ngIf="projeto?.level_priority" class="tag">Estratégico</div>
                <div *ngIf="projeto?.irfe_enabled_id" class="tag irfe">IRFE</div>
                <div *ngIf="projeto?.ircp_enabled_id" class="tag ircp">IRCP</div>
                <div *ngIf="hasTag(projeto, 144, 'pf_program')" class="tag plano_rio_grande">PLANO RIO GRANDE</div>
                <div *ngIf="hasTag(projeto, 172, 'pf_program')" class="tag plano_de_desenvolvimento">PLANO DESENVOLVIMENTO</div>
              </div>
            </td>
            <td>{{projeto?.agency_name}}</td>
            <!-- <td>{{projeto?.cron_foreseen_executed}}</td>
            <td>{{projeto?.cron_executed}}</td> -->
            <td class="status">
              <div *ngIf="projeto?.geral_analysis_status1 && projeto?.geral_analysis_stat_name">
                <span [innerHTML]="projeto?.geral_analysis_status1"></span>
                {{projeto?.geral_analysis_stat_name}}
              </div>
            </td>
            <td>
              {{projeto?.max_ctr_dth_atu ? projeto?.max_ctr_dth_atu : 'Não informado'}}
            </td>
            <td>
              <div class="btn-icon btn-icon-auto">
                <a [routerLink]="projeto.id" class="icon-table">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!projetoPesquisa?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Projeto Encontrado.</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" *ngIf="projetoPesquisa?.length">
      <pagination class="" [boundaryLinks]="true" [customFirstTemplate]="firstTemplate" [customLastTemplate]="lastTemplate" [customPreviousTemplate]="prevTemplate" [customNextTemplate]="nextTemplate" [totalItems]="projetoPesquisa?.length" [(ngModel)]="pagination.currentPage" [itemsPerPage]="pagination?.itemsPerPage" [maxSize]="pagination?.maxSize"></pagination>
      <ng-template #prevTemplate let-direction="direction">
        Anterior
      </ng-template>
      <ng-template #nextTemplate let-direction="direction">
        Próximo
      </ng-template>
      <ng-template #firstTemplate let-disabled="disabled" let-currentPage="currentPage">
        ...
      </ng-template>
      <ng-template #lastTemplate let-disabled="disabled" let-currentPage="currentPage">
        ...
      </ng-template>
    </div>
  </div>
</div>

<ng-template #modalPrint>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Impressão de Relatório</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Tipo de Relatório</label>
        <ng-select id="report_type" class="ng-select-alternative" [items]="reportList" [(ngModel)]="report_type" bindLabel="label" bindValue="id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type==2">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Análise</label>
        <ng-select id="report_2_param_2" class="ng-select-alternative" [items]="analiseList" [(ngModel)]="report_2_param_2" bindLabel="label" bindValue="id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type==2">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Tipo Análise</label>
        <ng-select id="report_2_param_1" class="ng-select-alternative" [items]="tipoAnaliseList" [(ngModel)]="report_2_param_1" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type==3">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Info</label>
        <ng-select id="report_3_param_1" class="ng-select-alternative" [items]="infoList" [(ngModel)]="report_3_param_1" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos">
        </ng-select>
      </div>
    </div>    

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="imprimirProjetos()">Imprimir</button>
      </div>
    </div>
  </div>
</ng-template>

<app-modal-responsavel #modalResonsavel></app-modal-responsavel>
<app-loading [loader]="isLoading"></app-loading>
<app-welcome [welcome]="isWelcome"></app-welcome>